/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * describes the pricing mode of an additional
 * @export
 */
export const Pricing = {
    Linear: 'LINEAR',
    Threshold: 'THRESHOLD',
    Graduated: 'GRADUATED'
} as const;
export type Pricing = typeof Pricing[keyof typeof Pricing];


export function PricingFromJSON(json: any): Pricing {
    return PricingFromJSONTyped(json, false);
}

export function PricingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pricing {
    return json as Pricing;
}

export function PricingToJSON(value?: Pricing | null): any {
    return value as any;
}

